export enum PlatformEnum {
    WEB = 'WEB', MOBILE = 'MOBILE', ERP = 'ERP', TRADE_COLLECTOR = 'TRADE_COLLECTOR'
}
